<template>
  <DetailContainer class="product-detail">
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'Product' })"
    ></PageHeader>
    <div slot="top" class="product-detail-top">
      <div class="basic">
        <hl-image
          :src="
            productInfo.img
              ? createImgUrl(productInfo.img)
              : require('../../../assets/head_default.png')
          "
          width="160px"
          height="160px"
          class="image"
        ></hl-image>
        <div class="info">
          <div class="info-header">
            <h3 class="title">{{ productInfo.name | format }}</h3>
            <el-tooltip effect="dark" :content="productInfo.statusName" placement="top">
              <hl-status
                :iconClass="(enbaleDisableStatus[productInfo.status] || {})['iconClass']"
                :color="(enbaleDisableStatus[productInfo.status] || {})['color']"
                :title="productInfo.statusName"
              ></hl-status>
            </el-tooltip>
          </div>
          <div class="info-tag">
            <hl-tag
              plain
              :color="(productTypeTag[productInfo.type] || {})['color']"
              :borderColor="(productTypeTag[productInfo.type] || {})['color']"
              v-if="productInfo.typeName"
            >
              {{ productInfo.typeName }}
            </hl-tag>
            <hl-tag plain :color="blueColor" :borderColor="blueColor">
              {{ productInfo.networkingModeName }}
            </hl-tag>
          </div>
          <div class="info-desc">
            <Descriptions :gutter="24">
              <DescriptionsItem labelWidth="auto" :label="$t('Product.protocol')">
                {{ productInfo.protocol | format }}
              </DescriptionsItem>
              <DescriptionsItem labelWidth="auto" :label="$t('Common.createTime')">
                {{ productInfo.createTime | formatTime }}
              </DescriptionsItem>
              <DescriptionsItem labelWidth="auto" :label="$t('Product.productSecretKey')">
                <span id="secret">
                  {{ productInfo.secret | format }}
                </span>
                <svg
                  class="icon icon-copy"
                  aria-hidden="true"
                  data-clipboard-target="#secret"
                  id="copySecret"
                >
                  <use xlink:href="#icon-copy" style="color: #2046c7"></use>
                </svg>
              </DescriptionsItem>
              <DescriptionsItem labelWidth="auto" :label="$t('Product.modelIdentifier')">
                <span id="identifier">
                  {{ productInfo.identifier | format }}
                </span>
                <svg
                  class="icon icon-copy"
                  aria-hidden="true"
                  data-clipboard-target="#identifier"
                  id="copyIdentifier"
                >
                  <use xlink:href="#icon-copy" style="color: #2046c7"></use>
                </svg>
              </DescriptionsItem>
              <DescriptionsItem
                labelWidth="auto"
                :span="24"
                :label="$t('Common.remark')"
                :contentStyle="{ wordBreak: 'break-all', wordWrap: 'break-word' }"
              >
                {{ productInfo.description | format }}
              </DescriptionsItem>
            </Descriptions>
          </div>
        </div>
      </div>
      <div class="statistic">
        <div class="statistic-num num-font">{{ productInfo.deviceNum | format }}</div>
        <div class="statistic-tip">{{ $t('Product.deviceNum') }}</div>
      </div>
    </div>
    <el-tabs v-model="activeTabName" class="product-detail-tabs">
      <el-tab-pane :label="$t('Product.funcDef')" name="funcSet" lazy v-if="tslRoleChildList">
        <FuncSet :tableData="tableData" :id="id" v-if="activeTabName === 'funcSet'" />
      </el-tab-pane>
      <el-tab-pane
        :label="$t('Product.CW')"
        name="configWizard"
        v-if="productInfo.type === 'refrigerator' && configWizardRoleChildList"
      >
        <SetUpNetGuide :productKey="productKey" v-if="activeTabName === 'configWizard'" />
      </el-tab-pane>

      <el-tab-pane
        :label="$t('Product.temperatureControl')"
        name="temperatureControl"
        v-if="productInfo.type === 'refrigerator' && temperatureControlRoleChildList"
      >
        <TemperatureControl
          :productKey="productKey"
          v-if="activeTabName === 'temperatureControl'"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$t('Product.paramsInfoTemp')"
        name="paramsInfoTemp"
        v-if="productInfo.type === 'refrigerator' && paramsInfoTempRoleChildList"
      >
        <ParamsInfo :productKey="productKey" v-if="activeTabName === 'paramsInfoTemp'" />
      </el-tab-pane>
      <el-tab-pane
        :label="$t('Product.deviceControlTemp')"
        name="deviceControlTemp"
        v-if="productInfo.type === 'refrigerator' && deviceControlTempRoleChildList"
      >
        <DeviceControlTemp :productKey="productKey" v-if="activeTabName === 'deviceControlTemp'" />
      </el-tab-pane>
      <el-tab-pane
        :label="$t('Product.paramsEditTemp')"
        name="paramsEditTemp"
        v-if="productInfo.type === 'refrigerator' && paramsEditTempRoleChildList"
      >
        <ParamsEditTemp :productKey="productKey" v-if="activeTabName === 'paramsEditTemp'" />
      </el-tab-pane>
    </el-tabs>
  </DetailContainer>
</template>

<script>
import ClipboardJS from 'clipboard'
import DetailContainer from '@/components/DetailContainer/index'
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import Image from '@/components/CommonTable/Image'
import Status from '@/components/CommonTable/Status'
import Tag from '@/components/CommonTable/Tag'
import { format, formatTime, formatNumWithComma, createImgUrl } from '@/utils/utils'
import { enbaleDisableStatus } from '@/config/status'
import { productTypeTag } from '@/config/tag'
import { getRoleByOperationCode, getRoute } from '@/authorized'
import { blueColor } from '@/style/var.scss'
import tablejson from './Model/Tablejson.TSL'
import FuncSet from './FrigProductDetailTab/FuncSet'
import ParamsInfo from './FrigProductDetailTab/ParamsInfo'
import DeviceControlTemp from './FrigProductDetailTab/DeviceControlTemp'
import ParamsEditTemp from './FrigProductDetailTab/ParamsEditTemp'
import SetUpNetGuide from './FrigProductDetailTab/SetUpNetGuide'
import TemperatureControl from './FrigProductDetailTab/TemperatureControl'
export default {
  components: {
    DetailContainer,
    Descriptions,
    DescriptionsItem,
    'hl-image': Image,
    'hl-status': Status,
    'hl-tag': Tag,
    FuncSet,
    ParamsInfo,
    DeviceControlTemp,
    ParamsEditTemp,
    SetUpNetGuide,
    TemperatureControl

    // Alert,
    // ProductTSL
  },
  data() {
    return {
      enbaleDisableStatus,
      productTypeTag,
      blueColor,
      tablejson,
      productInfo: {},
      visible: false,
      tableData: [],
      total: 0,
      productId: this.$route.query.id,
      productKey: this.$route.query.pk,
      version: '',
      id: '',
      activeTabName: ''
      // SecretClipboard:'',
    }
  },
  created() {
    if (this.tslRoleChildList) {
      this.activeTabName = 'funcSet'
    }

    this.getProductDetail()
    this.search()
  },
  mounted() {
    this.SecretClipboard = new ClipboardJS('#copySecret')
    this.onClipboard(this.SecretClipboard)
    this.IdentifierClipboard = new ClipboardJS('#copyIdentifier')
    this.onClipboard(this.IdentifierClipboard)
  },
  destroyed() {
    this.SecretClipboard.destroy()
    this.IdentifierClipboard.destroy()
  },
  computed: {
    roleChildList() {
      let path = '/product/model'.toLowerCase()
      let productModelRole = getRoute(path, this.$store.state.menus) || {}
      let detailRole = getRoleByOperationCode(productModelRole.childList, 'detail')
      return detailRole && detailRole.isPermission === 'Y' ? detailRole.childList : []
    },
    // 物模型TSL
    tslRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl')
      return val ? val.isPermission === 'Y' : false
    },
    tslRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'tsl')
      return role ? role.childList : []
    },
    configWizardRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'configWizard')
      return role ? role.isPermission === 'Y' : false
    },
    paramsInfoTempRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'paramsInfoTemp')
      return role ? role.isPermission === 'Y' : false
    },
    deviceControlTempRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'deviceControlTemp')
      return role ? role.isPermission === 'Y' : false
    },
    paramsEditTempRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'paramsEditTemp')
      return role ? role.isPermission === 'Y' : false
    },
    temperatureControlRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'temperatureControl')
      return role ? role.isPermission === 'Y' : false
    }
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  methods: {
    createImgUrl,
    onClipboard(clipboard) {
      clipboard.on('success', (e) => {
        this.$message.success(`${this.$t('Common.copySuccess')}`)
        e.clearSelection()
      })
      clipboard.on('error', () => {
        this.$message.success(`${this.$t('Common.copyFail')}`)
      })
    },
    async search() {
      let params = {
        productKey: this.productKey,
        draft: false
      }
      this.$ajax.get(this.$api.product.product_tsl_function_list, params).then((res) => {
        if (res.data) {
          this.id = res.data.id
          this.version = res.data.version
          this.tableData = res.data.functions
        }
      })
    },
    getProductDetail() {
      const params = {
        id: this.productId
      }
      return this.$ajax
        .get(this.$api.product.product_detail, params)
        .then((res) => {
          this.productInfo = res.data
        })
        .catch(() => {})
    },
    getStatus() {
      return enbaleDisableStatus[this.productInfo.status] || {}
    },
    toDraft() {
      this.$router.push({
        name: 'ProductDraft',
        query: {
          ...this.$route.query
        }
      })
    },
    handleTsl() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoepd>
.product-detail-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.basic {
  display: flex;
  width: 70%;
}
.image {
  flex-shrink: 0;
  border-radius: 16px;
}
.info {
  width: 100%;
  margin-left: 24px;
}
.info-header {
  display: flex;
  h3 {
    margin-right: 8px;
    font-size: 24px;
    color: #333333;
  }
}
.info-tag {
  margin-top: 12px;
  .hl-tag {
    margin-right: 8px;
  }
}
.info-desc {
  margin-top: 38px;
  // width: 70%;
}
.statistic {
  margin-top: 25px;
  width: 180px;
  height: 140px;
  flex-shrink: 0;
  background: url('../../../assets/device_bg.jpg') no-repeat left center / cover;
  border-radius: 15px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.statistic-num {
  font-size: 36px;
  color: #333333;
  font-weight: 600;
}
.statistic-tip {
  font-size: 14px;
  color: #666666;
}
.bottom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-content: center;
  }
  h3 {
    margin-right: 16px;
    line-height: 32px;
    font-size: 16px;
    color: #333333;
  }
}
.hl-alert {
  margin-top: 16px;
  margin-bottom: 8px;
}
</style>
